export interface ContactFormData {
  name: string;
  email: string;
  subject: string;
  message: string;
  gdprConsent: boolean;
}

const CONTACT_API_URL = 'https://b0n9rnvqa5.execute-api.eu-central-1.amazonaws.com/';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export class ContactApi {
  static validateFormData(formData: ContactFormData): { isValid: boolean; errors: string[] } {
    const errors: string[] = [];

    if (!formData.name.trim()) errors.push('Name is required.');
    if (!formData.email.trim() || !EMAIL_RE.test(formData.email)) errors.push('Please enter a valid email address.');
    if (!formData.subject.trim()) errors.push('Subject is required.');
    if (!formData.message.trim()) errors.push('Message is required.');
    if (!formData.gdprConsent) errors.push('You must accept the data processing consent to send the message.');

    return { isValid: errors.length === 0, errors };
  }

  static async sendContactEmail(
    formData: ContactFormData
  ): Promise<{ success: boolean; message: string }> {
    try {
      const response = await fetch(CONTACT_API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        return { success: false, message: data.message || 'An error occurred while sending the message.' };
      }

      return { success: true, message: data.message || 'Message sent successfully!' };
    } catch (error) {
      return {
        success: false,
        message: 'Could not reach the server. Please check your connection and try again.',
      };
    }
  }
}
